import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import useAuth from '../../auth/useAuth';
import './Login.css';

const getLoginErrorMessage = (error) => {
  if (error?.status === 401) {
    return 'Incorrect email or password.';
  }

  if (error?.status === 403) {
    return 'This account has been deactivated.';
  }

  return 'Sign-in failed. Please try again.';
};

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setIsSubmitting(true);

    try {
      await login({ email, password });
      navigate('/materials');
    } catch (error) {
      setErrorMessage(getLoginErrorMessage(error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="loginPage">
      <section className="loginCard" aria-labelledby="login-title">
        <h1 id="login-title">Sign in</h1>

        <form
          className="loginForm"
          onSubmit={handleSubmit}
          aria-busy={isSubmitting}
        >
          <div className="loginField">
            <label htmlFor="login-email">E-mail</label>
            <input
              id="login-email"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              disabled={isSubmitting}
              required
            />
          </div>

          <div className="loginField">
            <label htmlFor="login-password">Password</label>
            <div className="loginPasswordControl">
              <input
                id="login-password"
                type={showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                disabled={isSubmitting}
                required
              />
              <button
                className="loginPasswordToggle"
                type="button"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                aria-pressed={showPassword}
                disabled={isSubmitting}
                onClick={() => setShowPassword((currentValue) => !currentValue)}
              >
                <span aria-hidden="true">{showPassword ? '◉' : '○'}</span>
              </button>
            </div>
          </div>

          <div className="loginForgotPassword">
            <Link to="/forgot-password">Forgot password?</Link>
          </div>

          {errorMessage && (
            <p className="loginError" role="alert">
              {errorMessage}
            </p>
          )}

          <button
            className="loginSubmitButton"
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>

        <p className="loginRegisterText">
          Don't have an account yet?{' '}
          <Link to="/register">Create an account</Link>
        </p>
      </section>
    </main>
  );
};

export default Login;
